export default "__VITE_ASSET__5JGwxLl2__"